import { useEffect, useId } from "react"

export default function Dialog({
  isOpen,
  onClose,
  title,
  children,
  labelledById,
  className = "",
}) {
  const generatedId = useId()
  const headingId = labelledById || `${generatedId}-title`

  useEffect(() => {
    if (!isOpen) return

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        event.preventDefault()
        onClose?.()
      }
    }

    window.addEventListener("keydown", handleKeyDown)
    return () => window.removeEventListener("keydown", handleKeyDown)
  }, [isOpen, onClose])

  if (!isOpen) return null

  const handleBackdropMouseDown = (event) => {
    if (event.target === event.currentTarget) {
      onClose?.()
    }
  }

  return (
    <div className="dialog-backdrop" onMouseDown={handleBackdropMouseDown}>
      <div
        className={`dialog ${className}`.trim()}
        role="dialog"
        aria-modal="true"
        aria-labelledby={headingId}
      >
        <div className="dialog__header">
          <h3 className="dialog__title" id={headingId}>
            {title}
          </h3>
          {onClose && (
            <button
              type="button"
              className="dialog__close-button"
              onClick={onClose}
              aria-label="Close dialog"
            >
              ×
            </button>
          )}
        </div>
        <div className="dialog__body">{children}</div>
      </div>
    </div>
  )
}
